import React from "react";

export default function EmptyState({ icon: Icon, title, hint, action, testId, className = "" }) {
  return (
    <div data-testid={testId} className={`flex flex-col items-center justify-center text-center gap-3 px-6 py-12 rounded-lg border-2 border-dashed border-border/70 bg-muted/20 ${className}`}>
      {Icon && <div className="w-11 h-11 rounded-full bg-primary/10 text-primary flex items-center justify-center"><Icon className="w-5 h-5" /></div>}
      <div>
        <div className="text-sm font-semibold">{title}</div>
        {hint && <div className="text-xs text-muted-foreground mt-1 max-w-sm">{hint}</div>}
      </div>
      {action}
    </div>
  );
}
